import type { MutationCacheNotifyEvent } from '@tanstack/react-query'

import { useEffect, useRef } from 'react'
import { isEqual } from 'lodash/fp'

import { mutationCache } from '@/shared/lib/query-client'

export const useMutationObservers = ({
	mutationKey,
	onSuccess,
	onError,
	onPending,
}: {
	mutationKey: string[]
	onSuccess?: (variables: string[] | string) => void
	onError?: (error: Error) => void
	onPending?: (variables: string[]) => void
}) => {
	const mutationKeyRef = useRef(mutationKey)
	useEffect(() => {
		const callback = (event: MutationCacheNotifyEvent) => {
			if (
				event.type === 'updated' &&
				isEqual(event.mutation.options.mutationKey, mutationKeyRef.current)
			) {
				if (event.mutation.state.status === 'success') {
					onSuccess?.(event.mutation.state.variables)
				}
				if (event.mutation.state.status === 'error') {
					onError?.(event.mutation.state.error)
				}
				if (event.mutation.state.status === 'pending') {
					onPending?.(event.mutation.state.variables)
				}
			}
		}
		const unsubscribe = mutationCache.subscribe(callback)

		return () => unsubscribe()
	}, [onSuccess, mutationKeyRef])
}
